export const TRANSLATIONS = {
  MENU__HOMEPAGE: {
    pl: 'Strona głowna',
    en: 'Homepage',
  },
  MENU__ABOUT: {
    pl: 'O nas',
    en: 'About us',
  },
  MENU__NEWS: {
    pl: 'Aktualności',
    en: 'News',
  },
  MENU__ACHIEVEMENTS: {
    pl: 'Osiągnięcia',
    en: 'Achievements',
  },
  MENU__GALLERY: {
    pl: 'Galeria',
    en: 'Gallery',
  },
  MENU__REPERTOIRE: {
    pl: 'Repertuar',
    en: 'Repertoire',
  },
  MENU__CONTACT: {
    pl: 'Kontakt',
    en: 'Contact',
  },
  'MENU__ABOUT--DESCRIPTION': {
    pl: 'Bio',
    en: 'Bio',
  },
  'MENU__ABOUT--CV': {
    pl: 'CV',
    en: 'CV',
  },
  'MENU__ABOUT--RECRUITMENT': {
    pl: 'Nabór',
    en: 'Recruitment',
  },
  'MENU__ABOUT--STAFF': {
    pl: 'Kadra',
    en: 'Staff',
  },
  HERO__ABOUT_US: {
    pl: 'Więcej o nas',
    en: 'More about us',
  },
  'SOCIAL__YT--TITLE': {
    pl: 'Chór kameralny Tibi Domine | YT',
    en: 'Tibi Domine Choir | YT',
  },
  'SOCIAL__FB--TITLE': {
    pl: 'Chór kameralny Tibi Domine | FB',
    en: 'Tibi Domine Choir | FB',
  },
  CHANGE_LANGUAGE: {
    pl: 'Change language to english',
    en: 'Zmień język na polski',
  },
  WORK_IN_PROGRESS: {
    pl: 'Prace w toku',
    en: 'Work in progress',
  },
  'WORK_IN_PROGRESS--MESSAGE': {
    pl: 'Wróć do nas wkrótce!',
    en: 'Come back to us soon!',
  },
}
